import { ReactComponent as PhoneIcon } from '../icons/telephone.svg'
import { ReactComponent as MessageIcon } from '../icons/message.svg'

export const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <div className="cta-text">
            <h2 className="cta-title">
              ¿Listo para tener el mejor internet en casa?
            </h2>
            <p className="cta-description">
              Llámanos ahora y te ayudamos a elegir el plan perfecto para tu hogar.
              Servicio confiable y sin compromisos.
            </p>
            <div className="cta-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">🚀</span>
                <span>Activación en 24 horas</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">💰</span>
                <span>Precios transparentes</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">📞</span>
                <span>Atención personalizada</span>
              </div>
            </div>
          </div>

          <div className="cta-actions">
            <div className="contact-methods">
              <a href="tel:8180178779" className="contact-method primary">
                <PhoneIcon className="contact-icon" />
                <div className="contact-details">
                  <span className="contact-label">Llámanos ahora</span>
                  <span className="contact-value">81 8017 8779</span>
                </div>
              </a>
              
              <a 
                href="mailto:Interhomecontacto@gmail.com" 
                className="contact-method secondary"
              >
                <MessageIcon className="contact-icon" />
                <div className="contact-details">
                  <span className="contact-label">Escríbenos</span>
                  <span className="contact-value">Interhomecontacto@gmail.com</span>
                </div>
              </a>
            </div>

            <div className="cta-guarantee">
              <p className="guarantee-text">
                <strong>Garantía de satisfacción</strong>
                <br />
                Si no estás satisfecho en los primeros 30 días, 
                cancela sin penalizaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}